import type * as hast from 'hast';

import type { HastToGastTransformMap } from './types';
import { getStringAttribute } from './utils';

const prefersDarkColorRef = /.*prefers-color-scheme:\s*dark.*/gim;

export const transformFigures: HastToGastTransformMap = {
    figure: async (node: hast.Element, eat, context) => {
        // Extract the caption and the dark mode alternative
        let figcaption: hast.Element | undefined;
        let darkModePictureSource: string | undefined;
        const content: hast.Element[] = [];

        node.children.forEach((child) => {
            if (child.type === 'element' && child.tagName === 'figcaption') {
                figcaption = child;
            } else if (
                child.type === 'element' &&
                child.tagName === 'source' &&
                child.properties?.media?.toString().match(prefersDarkColorRef)
            ) {
                darkModePictureSource = getStringAttribute(child.properties, 'srcSet');
            } else if (child.type === 'element') {
                content.push(child);
            }
        });

        const figcaptionChildren = figcaption
            ? await eat('blocks', figcaption.children, context)
            : [];

        return eat('blocks', content ?? [], {
            ...context,
            parsedCaption: figcaptionChildren,
            darkModePictureSource,
            parseImagesAsBlocks: true, // This will ensure the image element will be transformed as an block_image
        });
    },

    picture: async (node: hast.Element, eat, context) => {
        // Extract the dark mode alternative
        let darkModePictureSource: string | undefined;
        const content: hast.Element[] = [];

        node.children.forEach((child) => {
            if (
                child.type === 'element' &&
                child.tagName === 'source' &&
                child.properties?.media?.toString().match(prefersDarkColorRef)
            ) {
                darkModePictureSource = getStringAttribute(child.properties, 'srcSet');
            } else if (child.type === 'element') {
                content.push(child);
            }
        });

        return eat('blocks', content, {
            ...context,
            darkModePictureSource,
        });
    },
};
